import $ from 'jquery';
import { Endpoint as _Endpoint, api as _api } from '../../data-core/dist';



// custom scrolll to element
const _scroll = ($element, delay = 0, speed = 500, callback = () => { }) => {
    setTimeout(() => {
        $('html, body').animate({ scrollTop: $element.offset().top }, speed, callback);
    }, delay);
};

// plugin export
const init = (opts = {}) => {

    const _defaults = {
        selector: {
            quiz: '#quiz',
            form: '.quiz-form',
            prev: '.quiz-prev',
            next: '.quiz-next',
            video: '.js-lightbox-video',

            step: '[name="step"]',
            radio: ':radio',
            checkbox: ':checkbox',
            select: 'select',
            input: 'input[type="text"]'
        },
        transition: {
            delay: 750,
            speed: 500
        },
        state: {
            loading: 'loading'
        },
        callback: {
            init: () => { },
            prev: () => { },
            next: () => { },
            error: () => { }
        }
    };

    // extend default options
    const options = $.extend(true, _defaults, opts);

    // static data
    const $quiz = $(options.selector.quiz);
    const $form = $quiz.find(options.selector.form);
    const method = $form.attr('method');
    const url = $form.attr('action');
    const endpoint = new _Endpoint(method, url);

    // api call
    const renderNextQuestion = () => {
        _api.call(endpoint, null, 'html')
            .then((html) => {
                setTimeout(() => {
                    $form.html(html);
                    $quiz.removeClass(options.state.loading);
                    _scroll($quiz, 0, options.transition.speed);
                    options.callback.next($form, html);
                }, options.transition.delay);
            })
            .catch((exc) => {
                $quiz.removeClass(options.state.loading);
                options.callback.error($form, exc);
            });
    };

    // radio change handler
    $form.on('change', options.selector.radio, function(event) {
        event.preventDefault();

        // response data
        const response = $(this).val();
        endpoint.data = {
            step: $form.find(options.selector.step).val(),
            responses: [response]
        };

        // show preloader
        $quiz.addClass(options.state.loading);

        // endpoint call
        renderNextQuestion(endpoint);
    });

    // next click handler
    $form.on('click', options.selector.next, function(event) {
        event.preventDefault();

        // response data
        const response = $form.find(`${options.selector.radio}:checked`).val();
        endpoint.data = {
            step: $form.find(options.selector.step).val(),
            responses: response ? [response] : []
        };

        // show preloader
        $quiz.addClass(options.state.loading);

        // endpoint call
        renderNextQuestion();
    });

    // initialize callback
    options.callback.init($form);
};

export default { init };
